export const wrap = fn => (...args) => fn(args)